import { Project } from "@/api/williams/project";
import { DateTime } from "@/util";

import styles from "./Dashboard.tsx.module.css";

export function ProjectDetails({ project }: { project: Project }) {
  const fields = [
    { label: "Project Number", value: project.number },
    { label: "Project Name", value: project.name },
    { label: "Description", value: project.description },
    { label: "Added From", value: project.addedFrom },
    { label: "Status", value: "Open" },
    { label: "Date Added", value: DateTime.getLocalDate(project.creationDate) },
    { label: "Last Date Accessed", value: DateTime.getLocalDate(project.lastUsedDate) ?? "Never" },
  ];

  const visibleFields = fields.filter((x) => x.value);

  return (
    <div className="d-lg-flex flex-wrap justify-content-between">
      {/* First column */}
      <ul className={styles.fieldList}>
        {visibleFields.slice(0, 5).map((field, index) => (
          <li key={index}>
            <label>{field.label}</label>
            <span>{field.value}</span>
          </li>
        ))}
      </ul>

      {/* Second column */}
      <ul className={styles.fieldList}>
        {visibleFields.slice(5, 10).map((field, index) => (
          <li key={index}>
            <label>{field.label}</label>
            <span>{field.value}</span>
          </li>
        ))}
      </ul>
    </div>
  );
}
